import Splide from '@splidejs/splide';

Drupal.behaviors.slider = {
  attach() {
    const sliders = document.querySelectorAll('.splide');
    sliders.forEach((slider) => {
      if (!slider.classList.contains('splide--processed')) {
        const autoplay = slider.attributes['data-autoplay'].value;
        const slidesPerView = slider.attributes['data-slides-per-view'].value;
        const arrows = slider.querySelector('.splide__arrows');
        const slides = slider.querySelectorAll('.splide__slide');
        if (slidesPerView === '4' && slides.length > 4) {
          arrows.classList.add('lg:block');
        }

        const splide = new Splide(slider, {
          arrows: true,
          perPage: slidesPerView,
          perMove: 1,
          autoplay: autoplay === '1',
          interval: 5000,
          rewind: true,
          pagination: true,
          gap: 30,
          breakpoints: {
            640: {
              clones: true,
              pagination: true,
              perPage: 1,
              perMove: 1,
            },
            768: {
              focus: 0,
              pagination: true,
              perPage: slidesPerView === '4' ? 2 : 1,
              perMove: slidesPerView === '4' ? 2 : 1,
            },
          },
        });

        splide.on('pagination:updated', function(data, prev, current) {
          for (let i = 0; i < data.items.length; i++) {
            data.items[i].li.style.display = 'none';
          }

          if (data.items.length < 2) {
            data.items[current.page].li.style.display = 'hidden';
          } else {
            data.items[current.page].button.style.width = '24px';
            data.items[current.page].button.style.height = '24px';
            data.items[current.page].li.style.display = 'inline-block';
            data.items[current.page].li.style.paddingTop = '10px';
          }

          let size = 0;
          let nbDots = 2;
          let previous = 0;
          let next = 0;

          if (((nbDots / 2) <= current.page ) && (current.page < data.items.length - 1)) {
            nbDots /= 2;
          }
          if (data.items.length < 2) {
            nbDots = 0;
          }

          for (let i = 1; i <= nbDots; i++) {
            size = 24;
            previous = current.page - i;
            if (0 <= previous) {
              data.items[previous].button.style.width = size.toString() + 'px';
              data.items[previous].button.style.height = size.toString() + 'px';
              data.items[previous].li.style.display = 'inline-block';
              data.items[previous].li.style.paddingTop = '10px';
            }
            next = current.page + i;
            if (next < data.items.length ) {
              data.items[next].button.style.width = size.toString() + 'px';
              data.items[next].button.style.height = size.toString() + 'px';
              data.items[next].li.style.display = 'inline-block';
              data.items[next].li.style.paddingTop = '10px';
            }
          }
        });

        splide.mount();
        slider.classList.add('splide--processed');
      }
    });
  },
};
